import { BRAND } from '@/constants/brand';
import { APP_SHELL_THEME } from './appShellTheme';

const text = APP_SHELL_THEME.text;
const textMuted = APP_SHELL_THEME.textMuted;
const panelBg = APP_SHELL_THEME.panelBg;
const panelBorder = APP_SHELL_THEME.panelBorder;
const pageBg = APP_SHELL_THEME.pageBg;
const inputBg = APP_SHELL_THEME.filterInputBg;
const inputBorder = APP_SHELL_THEME.filterBorder;
const tableFixedHeaderBg = APP_SHELL_THEME.tableFixedHeaderBg;
const tableFixedBodyBg = APP_SHELL_THEME.tableFixedBodyBg;
const tableFixedBodyHoverBg = APP_SHELL_THEME.tableFixedBodyHoverBg;
const tableFixedBodySelectedBg = APP_SHELL_THEME.tableFixedBodySelectedBg;
const metricCardBg = APP_SHELL_THEME.metricCardBg;
const metricCardBorder = APP_SHELL_THEME.metricCardBorder;
const accent = APP_SHELL_THEME.accent;
/* Accent as *text on the page*: plain lavanda is 3.78:1 on ink, under the AA
   floor. Use this for coloured labels/links; keep `accent` for fills and
   borders, where it sits behind white text and passes. */
const accentText = APP_SHELL_THEME.accentText;
const negativeText = APP_SHELL_THEME.negativeText;
const textStrong = APP_SHELL_THEME.textStrong;
const textBody = APP_SHELL_THEME.textBody;
const textSubtle = APP_SHELL_THEME.textSubtle;
const textFaint = APP_SHELL_THEME.textFaint;
const textDisabled = APP_SHELL_THEME.textDisabled;
const onAccent = APP_SHELL_THEME.onAccent;
const accentHover = APP_SHELL_THEME.accentHover;
const tableHeaderBg = APP_SHELL_THEME.tableHeaderBg;
const tableHeaderText = APP_SHELL_THEME.tableHeaderText;
const tableRowBorder = APP_SHELL_THEME.tableRowBorder;
const tableRowHoverBg = APP_SHELL_THEME.tableRowHoverBg;
const tableRowSelectedBg = APP_SHELL_THEME.tableRowSelectedBg;
const hoverBg = APP_SHELL_THEME.hoverBg;
const menuHoverBg = APP_SHELL_THEME.menuHoverBg;
const descriptionsBg = APP_SHELL_THEME.descriptionsBg;
const descriptionsStrongBorder = APP_SHELL_THEME.descriptionsStrongBorder;
const selectTagBg = APP_SHELL_THEME.selectTagBg;
const chipBg = APP_SHELL_THEME.chipBg;
const chipBorder = APP_SHELL_THEME.chipBorder;
const chipText = APP_SHELL_THEME.chipText;
const chipDisabledBg = APP_SHELL_THEME.chipDisabledBg;
const chipDisabledBorder = APP_SHELL_THEME.chipDisabledBorder;
const popupShadow = APP_SHELL_THEME.popupShadow;
const cardShadow = APP_SHELL_THEME.cardShadow;
const tableSurfaceBg = APP_SHELL_THEME.tableSurfaceBg;
const tableSurfaceShadow = APP_SHELL_THEME.tableSurfaceShadow;

/** Ant Design + typography overrides for the app shell. Colours resolve per
 *  light/dark mode through the CSS variables behind APP_SHELL_THEME. */
export const appShellGlobalStyles = `
  .app-shell-main {
    background-color: ${APP_SHELL_THEME.pageBg};
    color: ${text};
  }

  .app-shell-main,
  .ant-layout-content {
    background-color: ${APP_SHELL_THEME.pageBg};
    color: ${text};
  }

  /* —— Typography —— */
  .app-shell-main .ant-typography,
  .ant-layout-header.app-shell-header .ant-typography,
  .ant-layout-content .ant-typography {
    color: ${textStrong} !important;
  }

  .app-shell-main .ant-typography.ant-typography-secondary,
  .ant-layout-content .ant-typography.ant-typography-secondary {
    color: ${textMuted} !important;
  }

  .app-shell-main label,
  .ant-layout-content label,
  .app-shell-main .ant-form-item-label > label,
  .ant-layout-content .ant-form-item-label > label {
    color: ${textBody} !important;
  }

  .app-shell-main .ant-form-item-explain,
  .ant-layout-content .ant-form-item-explain,
  .app-shell-main .ant-form-item-extra,
  .ant-layout-content .ant-form-item-extra {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-typography strong,
  .ant-layout-content .ant-typography strong {
    color: ${textStrong} !important;
  }

  .app-shell-main span,
  .app-shell-main p,
  .ant-layout-content span,
  .ant-layout-content p {
    color: inherit;
  }

  /* —— Header bar —— */
  .ant-layout-header.app-shell-header {
    background-color: ${APP_SHELL_THEME.pageBg} !important;
    border-bottom: 1px solid ${panelBorder};
  }

  /* —— Descriptions / summary grids —— */
  .app-shell-main .ant-descriptions-item-label,
  .ant-layout-content .ant-descriptions-item-label {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-descriptions-item-content,
  .ant-layout-content .ant-descriptions-item-content {
    color: ${textStrong} !important;
  }

  .app-shell-main .ant-descriptions-bordered .ant-descriptions-item-label,
  .app-shell-main .ant-descriptions-bordered .ant-descriptions-item-content,
  .ant-layout-content .ant-descriptions-bordered .ant-descriptions-item-label,
  .ant-layout-content .ant-descriptions-bordered .ant-descriptions-item-content {
    border-color: ${panelBorder} !important;
    background: ${descriptionsBg} !important;
  }

  /* —— Cards —— */
  .app-shell-main .ant-card,
  .ant-layout-content .ant-card {
    background: ${panelBg} !important;
    border-color: ${panelBorder} !important;
    box-shadow: ${cardShadow};
    color: ${text};
  }

  .app-shell-main .ant-card-head,
  .ant-layout-content .ant-card-head {
    border-bottom-color: ${panelBorder} !important;
    color: ${text} !important;
  }

  .app-shell-main .ant-card-head-title,
  .ant-layout-content .ant-card-head-title {
    color: ${textStrong} !important;
  }

  .app-shell-main .ant-card.metric-card,
  .ant-layout-content .ant-card.metric-card {
    background: ${metricCardBg} !important;
    border-color: ${metricCardBorder} !important;
    box-shadow: ${cardShadow} !important;
  }

  .app-shell-main .ant-card.metric-card .ant-card-body,
  .ant-layout-content .ant-card.metric-card .ant-card-body {
    background: transparent !important;
  }

  .app-shell-main .ant-card.metric-card .ant-statistic-title,
  .ant-layout-content .ant-card.metric-card .ant-statistic-title,
  .ant-modal .ant-card.metric-card .ant-statistic-title {
    color: ${textFaint} !important;
  }

  .app-shell-main .ant-card.metric-card .ant-statistic-content-value,
  .ant-layout-content .ant-card.metric-card .ant-statistic-content-value,
  .ant-modal .ant-card.metric-card .ant-statistic-content-value {
    color: ${textStrong} !important;
  }

  /* —— Statistics —— */
  .app-shell-main .ant-statistic-title,
  .ant-layout-content .ant-statistic-title {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-statistic-content,
  .app-shell-main .ant-statistic-content-value,
  .ant-layout-content .ant-statistic-content,
  .ant-layout-content .ant-statistic-content-value {
    color: ${text} !important;
  }

  /* —— Tables —— */
  .app-shell-main .ant-table-wrapper,
  .ant-layout-content .ant-table-wrapper {
    background: transparent !important;
  }

  .app-shell-main .ant-table,
  .ant-layout-content .ant-table {
    background: ${tableSurfaceBg} !important;
    box-shadow: ${tableSurfaceShadow};
    color: ${text};
  }

  /* A table inside a card or modal already sits on a surface of its own. */
  .app-shell-main .ant-card .ant-table,
  .ant-layout-content .ant-card .ant-table {
    background: transparent !important;
    box-shadow: none;
  }

  .app-shell-main .ant-table-placeholder,
  .ant-layout-content .ant-table-placeholder {
    background: transparent !important;
  }

  .app-shell-main .ant-table-placeholder > td,
  .ant-layout-content .ant-table-placeholder > td {
    background: transparent !important;
  }

  .app-shell-main .ant-table-container,
  .app-shell-main .ant-table-content,
  .app-shell-main .ant-table-body,
  .app-shell-main .ant-table-header,
  .ant-layout-content .ant-table-container,
  .ant-layout-content .ant-table-content,
  .ant-layout-content .ant-table-body,
  .ant-layout-content .ant-table-header {
    background: transparent !important;
  }

  .app-shell-main .ant-table-thead > tr > th,
  .ant-layout-content .ant-table-thead > tr > th {
    background: ${tableHeaderBg} !important;
    /* White rather than the accent. Lavanda on a lavanda tint was the same hue
       on itself at 5.06:1; white on the same ground is 15.95:1, and a header
       is a label to be read rather than something to draw the eye. */
    color: ${tableHeaderText} !important;
    border-bottom: 1px solid ${panelBorder} !important;
    /* Title Case every word, so headers read as labels rather than sentences
       without having to be written that way in each table's definition. */
    text-transform: capitalize;
  }

  .app-shell-main .ant-table-tbody > tr > td,
  .ant-layout-content .ant-table-tbody > tr > td {
    background: transparent !important;
    border-bottom: 1px solid ${tableRowBorder} !important;
    color: ${textStrong} !important;
    /* Nearer a spreadsheet row than antd's default, so a long booking list
       reads as a dense grid rather than a stack of cards. Padding rather than
       a fixed height, so a wrapped cell still grows instead of clipping. */
    padding-block: 6px !important;
    line-height: 1.35 !important;
  }

  .app-shell-main .ant-table-tbody > tr:hover > td,
  .ant-layout-content .ant-table-tbody > tr:hover > td {
    background: ${tableRowHoverBg} !important;
  }

  .app-shell-main .ant-table-tbody > tr.ant-table-row-selected > td,
  .ant-layout-content .ant-table-tbody > tr.ant-table-row-selected > td {
    background: ${tableRowSelectedBg} !important;
  }

  /* Fixed columns: solid block backgrounds so scrolled columns tuck underneath */
  .app-shell-main .ant-table-cell-fix-left,
  .app-shell-main .ant-table-cell-fix-right,
  .ant-layout-content .ant-table-cell-fix-left,
  .ant-layout-content .ant-table-cell-fix-right,
  .ant-modal .ant-table-cell-fix-left,
  .ant-modal .ant-table-cell-fix-right {
    z-index: 2 !important;
    background-clip: padding-box !important;
  }

  .app-shell-main .ant-table-cell-fix-right-first,
  .ant-layout-content .ant-table-cell-fix-right-first,
  .ant-modal .ant-table-cell-fix-right-first {
    border-left: 1px solid ${panelBorder} !important;
  }

  .app-shell-main .ant-table-thead > tr > th.ant-table-cell-fix-left,
  .app-shell-main .ant-table-thead > tr > th.ant-table-cell-fix-right,
  .ant-layout-content .ant-table-thead > tr > th.ant-table-cell-fix-left,
  .ant-layout-content .ant-table-thead > tr > th.ant-table-cell-fix-right,
  .ant-modal .ant-table-thead > tr > th.ant-table-cell-fix-left,
  .ant-modal .ant-table-thead > tr > th.ant-table-cell-fix-right {
    background: ${tableFixedHeaderBg} !important;
    z-index: 4 !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .app-shell-main .ant-table-tbody > tr > td.ant-table-cell-fix-left,
  .app-shell-main .ant-table-tbody > tr > td.ant-table-cell-fix-right,
  .ant-layout-content .ant-table-tbody > tr > td.ant-table-cell-fix-left,
  .ant-layout-content .ant-table-tbody > tr > td.ant-table-cell-fix-right,
  .ant-modal .ant-table-tbody > tr > td.ant-table-cell-fix-left,
  .ant-modal .ant-table-tbody > tr > td.ant-table-cell-fix-right {
    background: ${tableFixedBodyBg} !important;
  }

  .app-shell-main .ant-table-tbody > tr:hover > td.ant-table-cell-fix-left,
  .app-shell-main .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right,
  .ant-layout-content .ant-table-tbody > tr:hover > td.ant-table-cell-fix-left,
  .ant-layout-content .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right,
  .ant-modal .ant-table-tbody > tr:hover > td.ant-table-cell-fix-left,
  .ant-modal .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right {
    background: ${tableFixedBodyHoverBg} !important;
  }

  .app-shell-main .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-left,
  .app-shell-main .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-right,
  .ant-layout-content .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-left,
  .ant-layout-content .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-right,
  .ant-modal .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-left,
  .ant-modal .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-right {
    background: ${tableFixedBodySelectedBg} !important;
  }

  /* Mask strip to the left of the fixed Actions column while horizontal scrolling */
  .app-shell-main .ant-table-thead > tr > th.ant-table-cell-fix-right-first::after,
  .ant-layout-content .ant-table-thead > tr > th.ant-table-cell-fix-right-first::after,
  .ant-modal .ant-table-thead > tr > th.ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
    background: ${tableFixedHeaderBg} !important;
  }

  .app-shell-main .ant-table-tbody > tr > td.ant-table-cell-fix-right-first::after,
  .ant-layout-content .ant-table-tbody > tr > td.ant-table-cell-fix-right-first::after,
  .ant-modal .ant-table-tbody > tr > td.ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
    background: ${tableFixedBodyBg} !important;
    /* antd extends the strip 1px below the cell, over the row divider, which
       left a gap in every divider just before the Actions column. */
    bottom: 0 !important;
  }

  .app-shell-main .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right-first::after,
  .ant-layout-content .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right-first::after,
  .ant-modal .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right-first::after {
    background: ${tableFixedBodyHoverBg} !important;
  }

  .app-shell-main .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-right-first::after,
  .ant-layout-content .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-right-first::after,
  .ant-modal .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell-fix-right-first::after {
    background: ${tableFixedBodySelectedBg} !important;
  }

  .app-shell-main .ant-table-cell-fix-left-last::after,
  .app-shell-main .ant-table-cell-fix-right-first::before,
  .ant-layout-content .ant-table-cell-fix-left-last::after,
  .ant-layout-content .ant-table-cell-fix-right-first::before,
  .ant-modal .ant-table-cell-fix-left-last::after,
  .ant-modal .ant-table-cell-fix-right-first::before,
  .app-shell-main .ant-table-cell-fix-left-last::before,
  .ant-layout-content .ant-table-cell-fix-left-last::before,
  .ant-modal .ant-table-cell-fix-left-last::before {
    box-shadow: none !important;
  }

  .app-shell-main .ant-table-summary > tr > td,
  .app-shell-main .ant-table-summary > tr > th,
  .ant-layout-content .ant-table-summary > tr > td,
  .ant-layout-content .ant-table-summary > tr > th {
    background: ${panelBg} !important;
    color: ${text} !important;
    border-top: 1px solid ${panelBorder} !important;
  }

  .app-shell-main .ant-table-column-sorter,
  .app-shell-main .ant-table-filter-trigger,
  .ant-layout-content .ant-table-column-sorter,
  .ant-layout-content .ant-table-filter-trigger {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-table-column-sorter-up.active,
  .app-shell-main .ant-table-column-sorter-down.active,
  .app-shell-main .ant-table-filter-trigger.active,
  .ant-layout-content .ant-table-column-sorter-up.active,
  .ant-layout-content .ant-table-column-sorter-down.active,
  .ant-layout-content .ant-table-filter-trigger.active {
    color: ${accentText} !important;
  }

  /* —— Pagination —— */
  .app-shell-main .ant-pagination,
  .app-shell-main .ant-pagination .ant-pagination-item a,
  .ant-layout-content .ant-pagination,
  .ant-layout-content .ant-pagination .ant-pagination-item a {
    color: ${textMuted};
  }

  .app-shell-main .ant-pagination .ant-pagination-item,
  .ant-layout-content .ant-pagination .ant-pagination-item {
    background: ${panelBg};
    border-color: ${panelBorder};
  }

  .app-shell-main .ant-pagination .ant-pagination-item-active,
  .ant-layout-content .ant-pagination .ant-pagination-item-active {
    background: ${inputBg};
    border-color: ${accent};
  }

  .app-shell-main .ant-pagination .ant-pagination-item-active a,
  .ant-layout-content .ant-pagination .ant-pagination-item-active a {
    color: ${text} !important;
  }

  .app-shell-main .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
  .app-shell-main .ant-pagination .ant-pagination-next .ant-pagination-item-link,
  .ant-layout-content .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
  .ant-layout-content .ant-pagination .ant-pagination-next .ant-pagination-item-link {
    background: ${panelBg} !important;
    border-color: ${panelBorder} !important;
    color: ${textMuted} !important;
  }

  /* —— Inputs —— */
  .app-shell-main .ant-input,
  .app-shell-main .ant-input-affix-wrapper,
  .app-shell-main .ant-input-number,
  .app-shell-main .ant-input-number .ant-input-number-input,
  .app-shell-main .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .app-shell-main .ant-picker,
  .ant-layout-content .ant-input,
  .ant-layout-content .ant-input-affix-wrapper,
  .ant-layout-content .ant-input-number,
  .ant-layout-content .ant-input-number .ant-input-number-input,
  .ant-layout-content .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-layout-content .ant-picker {
    background: ${inputBg} !important;
    border-color: ${inputBorder} !important;
    color: ${text} !important;
  }

  .app-shell-main .ant-input::placeholder,
  .app-shell-main .ant-input-affix-wrapper input::placeholder,
  .ant-layout-content .ant-input::placeholder,
  .ant-layout-content .ant-input-affix-wrapper input::placeholder {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-select-selection-item,
  .app-shell-main .ant-select-selection-placeholder,
  .ant-layout-content .ant-select-selection-item,
  .ant-layout-content .ant-select-selection-placeholder {
    color: ${text} !important;
  }

  .app-shell-main .ant-select-selection-placeholder,
  .ant-layout-content .ant-select-selection-placeholder {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-select-multiple .ant-select-selection-item,
  .ant-layout-content .ant-select-multiple .ant-select-selection-item {
    background: ${selectTagBg} !important;
    color: ${text} !important;
    border: none !important;
  }

  .app-shell-main .ant-select .ant-select-selection-search-input,
  .ant-layout-content .ant-select .ant-select-selection-search-input {
    color: ${text} !important;
  }

  .app-shell-main .ant-picker .ant-picker-input > input,
  .ant-layout-content .ant-picker .ant-picker-input > input {
    color: ${text} !important;
  }

  .app-shell-main .ant-picker .ant-picker-input > input::placeholder,
  .ant-layout-content .ant-picker .ant-picker-input > input::placeholder {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-input-number .ant-input-number-input::placeholder,
  .ant-layout-content .ant-input-number .ant-input-number-input::placeholder {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-select-arrow,
  .app-shell-main .ant-picker-suffix,
  .app-shell-main .ant-input-number-handler-wrap,
  .ant-layout-content .ant-select-arrow,
  .ant-layout-content .ant-picker-suffix {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-input-search .ant-input-search-button,
  .ant-layout-content .ant-input-search .ant-input-search-button {
    background: ${inputBg} !important;
    border-color: ${inputBorder} !important;
    color: ${text} !important;
  }

  .app-shell-main .ant-input-show-count-suffix,
  .app-shell-main .ant-input-data-count,
  .ant-layout-content .ant-input-show-count-suffix,
  .ant-layout-content .ant-input-data-count,
  .ant-modal .ant-input-show-count-suffix,
  .ant-modal .ant-input-data-count {
    color: ${textSubtle} !important;
  }

  .app-shell-main .ant-input-textarea-show-count::after,
  .ant-layout-content .ant-input-textarea-show-count::after,
  .ant-modal .ant-input-textarea-show-count::after {
    color: ${textSubtle} !important;
  }

  /* —— Buttons (text / default on dark) —— */
  .app-shell-main .ant-btn-text:not(.ant-btn-dangerous),
  .ant-layout-content .ant-btn-text:not(.ant-btn-dangerous),
  .ant-modal .ant-btn-text:not(.ant-btn-dangerous) {
    color: ${textBody} !important;
  }

  .app-shell-main .ant-btn-text:not(.ant-btn-dangerous) .anticon,
  .ant-layout-content .ant-btn-text:not(.ant-btn-dangerous) .anticon,
  .ant-modal .ant-btn-text:not(.ant-btn-dangerous) .anticon {
    color: ${textBody} !important;
  }

  .app-shell-main .ant-btn-text:not(.ant-btn-dangerous):hover,
  .ant-layout-content .ant-btn-text:not(.ant-btn-dangerous):hover,
  .ant-modal .ant-btn-text:not(.ant-btn-dangerous):hover {
    background: ${hoverBg} !important;
    color: ${text} !important;
  }

  .app-shell-main .ant-btn-link:not(.ant-btn-dangerous),
  .ant-layout-content .ant-btn-link:not(.ant-btn-dangerous),
  .ant-modal .ant-btn-link:not(.ant-btn-dangerous) {
    color: ${accentText} !important;
  }

  /* Danger text/link buttons sit directly on the ink page background, where
     antd's dark-algorithm red (#db2622) is 3.89:1 — below the AA floor. The
     lighter red keeps the destructive signal and reaches 7.4:1. */
  .app-shell-main .ant-btn-dangerous.ant-btn-text,
  .app-shell-main .ant-btn-dangerous.ant-btn-link,
  .ant-layout-content .ant-btn-dangerous.ant-btn-text,
  .ant-layout-content .ant-btn-dangerous.ant-btn-link,
  .ant-modal .ant-btn-dangerous.ant-btn-text,
  .ant-modal .ant-btn-dangerous.ant-btn-link {
    color: ${negativeText} !important;
  }

  /* A default (outlined) danger button was picking up the light-surface
     treatment the rest of the default buttons get on this shell, which left a
     destructive action looking exactly like a neutral one. */
  .app-shell-main .ant-btn-dangerous.ant-btn-default,
  .ant-layout-content .ant-btn-dangerous.ant-btn-default,
  .ant-modal .ant-btn-dangerous.ant-btn-default {
    color: ${negativeText} !important;
    border-color: rgba(255, 120, 117, 0.5) !important;
    background: rgba(255, 120, 117, 0.1) !important;
  }

  .app-shell-main .ant-btn-dangerous.ant-btn-default:hover,
  .ant-layout-content .ant-btn-dangerous.ant-btn-default:hover,
  .ant-modal .ant-btn-dangerous.ant-btn-default:hover {
    border-color: ${negativeText} !important;
    background: rgba(255, 120, 117, 0.18) !important;
  }

  /* Disabled buttons. The legacy rules in globalStyles paint them light grey on
     light grey, which on the dark shell reads as a muted chip but on the light
     shell all but disappears. */
  html[data-theme='light'] .ant-btn:disabled,
  html[data-theme='light'] .ant-btn.ant-btn-disabled {
    color: ${textDisabled} !important;
    background: ${hoverBg} !important;
    border-color: ${panelBorder} !important;
  }

  /* —— Empty / spin —— */
  .app-shell-main .ant-empty-description,
  .ant-layout-content .ant-empty-description {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-spin-text,
  .ant-layout-content .ant-spin-text {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-spin-container.ant-spin-blur,
  .ant-layout-content .ant-spin-container.ant-spin-blur {
    opacity: 0.5;
  }

  .app-shell-main .ant-spin-container.ant-spin-blur::after,
  .ant-layout-content .ant-spin-container.ant-spin-blur::after {
    background: ${pageBg} !important;
    opacity: 0.6 !important;
  }

  .app-shell-main .ant-spin-nested-loading > div > .ant-spin,
  .app-shell-main .ant-spin-nested-loading > div > .ant-spin-spinning,
  .ant-layout-content .ant-spin-nested-loading > div > .ant-spin,
  .ant-layout-content .ant-spin-nested-loading > div > .ant-spin-spinning {
    background: transparent !important;
  }

  .app-shell-main .ant-spin-dot-item,
  .ant-layout-content .ant-spin-dot-item {
    background-color: ${accent} !important;
  }

  .app-shell-main .ant-table-wrapper .ant-spin-nested-loading,
  .ant-layout-content .ant-table-wrapper .ant-spin-nested-loading {
    background: transparent !important;
  }

  /* —— Sub navigation —— */
  .app-shell-subnav.ant-menu-horizontal {
    background: ${APP_SHELL_THEME.pageBg} !important;
    border-bottom: 1px solid ${panelBorder} !important;
  }

  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item,
  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item a {
    color: ${textMuted} !important;
  }

  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item-selected,
  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item-selected a {
    color: ${text} !important;
  }

  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item:hover,
  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item:hover a {
    color: ${textBody} !important;
  }

  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item-selected::after,
  .app-shell-subnav.ant-menu-horizontal > .ant-menu-item:hover::after {
    border-bottom-color: ${accent} !important;
  }

  /* —— Dropdowns / pickers (portals) —— */
  .ant-select-dropdown,
  .ant-picker-dropdown .ant-picker-panel-container {
    background: ${panelBg} !important;
    border: 1px solid ${panelBorder};
  }

  .ant-select-dropdown .ant-select-item {
    color: ${textBody} !important;
  }

  .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled),
  .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: ${inputBg} !important;
    color: ${text} !important;
  }

  .ant-picker-dropdown .ant-picker-header,
  .ant-picker-dropdown .ant-picker-content th,
  .ant-picker-dropdown .ant-picker-cell {
    color: ${textBody} !important;
  }

  .ant-picker-dropdown .ant-picker-header button {
    color: ${textMuted} !important;
  }

  .ant-picker-dropdown .ant-picker-header-view button {
    color: ${textStrong} !important;
  }

  .ant-picker-dropdown .ant-picker-panel,
  .ant-picker-dropdown .ant-picker-panels {
    background: ${panelBg} !important;
    border-color: ${panelBorder} !important;
  }

  .ant-picker-dropdown .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
    background: rgba(97, 97, 215, 0.28) !important;
    color: ${text} !important;
  }

  .ant-picker-dropdown .ant-picker-cell-disabled .ant-picker-cell-inner {
    color: ${textDisabled} !important;
  }

  /* Month / date range selection — lavanda highlight, white text (not grey-on-white) */
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
    background: rgba(97, 97, 215, 0.32) !important;
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
    background: ${accent} !important;
    color: ${onAccent} !important;
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range .ant-picker-cell-inner {
    color: ${text} !important;
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
    border-color: ${accent} !important;
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-hover::before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-hover-start::before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-hover-end::before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start::before,
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end::before {
    background: rgba(97, 97, 215, 0.22) !important;
  }

  .ant-picker-dropdown .ant-picker-cell-range-hover .ant-picker-cell-inner,
  .ant-picker-dropdown .ant-picker-cell-range-hover-start .ant-picker-cell-inner,
  .ant-picker-dropdown .ant-picker-cell-range-hover-end .ant-picker-cell-inner {
    color: ${text} !important;
  }

  .ant-picker-dropdown .ant-picker-footer,
  .ant-picker-dropdown .ant-picker-header {
    border-color: ${panelBorder} !important;
  }

  .ant-picker-dropdown .ant-picker-now-btn,
  .ant-picker-dropdown .ant-picker-today-btn {
    color: ${accentText} !important;
  }

  /* Table column filter dropdown (portaled — Rate Cards, Media Plan list, etc.) */
  .ant-dropdown:has(.ant-table-filter-dropdown) {
    z-index: 1100 !important;
  }

  /* —— Action dropdown menus (row/kebab menus) ——
     Only the table filter dropdown was themed for dark before, so plain action
     menus (Edit / Raise IO / Delete) fell back to dark text on a dark surface
     and were unreadable. Theme them like the filter dropdown. */
  .ant-dropdown:not(:has(.ant-table-filter-dropdown)) .ant-dropdown-menu {
    background: ${panelBg} !important;
    border: 1px solid ${panelBorder} !important;
    box-shadow: 0 8px 24px ${popupShadow} !important;
  }

  .ant-dropdown:not(:has(.ant-table-filter-dropdown))
    .ant-dropdown-menu-item:not(.ant-dropdown-menu-item-danger) {
    color: ${textBody} !important;
  }

  .ant-dropdown:not(:has(.ant-table-filter-dropdown)) .ant-dropdown-menu-item:hover {
    background: ${menuHoverBg} !important;
  }

  /* Destructive menu items keep their red. The blanket white above was
     overriding antd's own danger colour, so "Delete" and "Cancel this IO"
     read exactly like the harmless items above them. The lighter red clears
     the AA floor on this ground, where antd's own (#db2622) does not. */
  .ant-dropdown .ant-dropdown-menu-item-danger,
  .ant-dropdown .ant-dropdown-menu-item-danger .ant-dropdown-menu-title-content {
    color: ${negativeText} !important;
  }

  .ant-dropdown .ant-dropdown-menu-item-danger:hover {
    background: rgba(255, 120, 117, 0.14) !important;
  }

  .ant-dropdown .ant-table-filter-dropdown,
  .ant-table-filter-dropdown {
    background: ${tableFixedHeaderBg} !important;
    border: 1px solid ${panelBorder};
    box-shadow: 0 8px 24px ${popupShadow};
    z-index: 1100;
  }

  .ant-table-filter-dropdown .ant-dropdown-menu {
    background: ${tableFixedHeaderBg} !important;
    border: none !important;
    box-shadow: none !important;
    padding: 4px 0;
  }

  .ant-table-filter-dropdown .ant-dropdown-menu-item,
  .ant-table-filter-dropdown .ant-dropdown-menu-submenu-title {
    color: ${textBody} !important;
    background: transparent !important;
  }

  .ant-table-filter-dropdown .ant-dropdown-menu-item:hover,
  .ant-table-filter-dropdown .ant-dropdown-menu-submenu-title:hover {
    background: ${menuHoverBg} !important;
    color: ${text} !important;
  }

  .ant-table-filter-dropdown .ant-checkbox-wrapper,
  .ant-table-filter-dropdown .ant-checkbox-wrapper + span {
    color: ${textBody} !important;
  }

  .ant-table-filter-dropdown .ant-checkbox .ant-checkbox-inner {
    background: transparent !important;
    border-color: ${panelBorder} !important;
  }

  .ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-inner,
  .ant-table-filter-dropdown .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
    background: ${accent} !important;
    border-color: ${accent} !important;
  }

  .ant-table-filter-dropdown .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border-color: ${accent} !important;
  }

  .ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: ${onAccent} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns {
    background: ${tableFixedHeaderBg} !important;
    border-top: 1px solid ${panelBorder} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link:not(.ant-btn-dangerous) {
    color: ${textSubtle} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link:not(.ant-btn-dangerous):hover {
    color: ${text} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-primary {
    background: ${accent} !important;
    border-color: ${accent} !important;
    color: ${onAccent} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-primary:hover {
    background: ${accentHover} !important;
    border-color: ${accentHover} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-search {
    border-bottom-color: ${panelBorder} !important;
    padding: 8px;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-search .ant-input {
    background: ${inputBg} !important;
    border-color: ${inputBorder} !important;
    color: ${text} !important;
  }

  /* —— Modals —— */
  .ant-modal .ant-modal-content {
    background: ${panelBg} !important;
    color: ${text};
  }

  /* —— Drawers ——
     Drawers render in a body portal (like modals) with no dark theming of their
     own, so mirror the modal treatment: dark surface + readable text/tables. */
  .ant-drawer .ant-drawer-content,
  .ant-drawer .ant-drawer-header,
  .ant-drawer .ant-drawer-body {
    background: ${panelBg} !important;
  }

  .ant-drawer .ant-drawer-header {
    border-bottom-color: ${panelBorder} !important;
  }

  .ant-drawer .ant-drawer-title,
  .ant-drawer .ant-drawer-body,
  .ant-drawer .ant-typography {
    color: ${textStrong} !important;
  }

  .ant-drawer .ant-typography.ant-typography-secondary {
    color: ${textMuted} !important;
  }

  .ant-drawer .ant-drawer-close {
    color: ${textMuted} !important;
  }

  .ant-drawer .ant-table {
    background: transparent !important;
  }

  .ant-drawer .ant-table-thead > tr > th {
    background: ${tableHeaderBg} !important;
    color: ${accentText} !important;
    border-bottom: 1px solid ${panelBorder} !important;
  }

  .ant-drawer .ant-table-tbody > tr > td {
    background: transparent !important;
    color: ${textStrong} !important;
    border-bottom: 1px solid ${tableRowBorder} !important;
  }

  .ant-drawer .ant-table-tbody > tr:hover > td {
    background: ${tableRowHoverBg} !important;
  }

  /* Forms inside drawers (e.g. Raise IO): labels, checkbox text and footer.
     Raise specificity with .ant-drawer-body so this beats antd's runtime
     label styling and the drawer sits outside .app-shell-main. */
  .ant-drawer .ant-drawer-body label,
  .ant-drawer .ant-drawer-body .ant-form-item-label > label,
  .ant-drawer .ant-drawer-body .ant-checkbox-wrapper,
  .ant-drawer .ant-drawer-body .ant-checkbox-wrapper > span {
    color: ${text} !important;
  }

  /* Inputs/selects inside drawers — mirror the modal treatment so typed text,
     placeholders and the select box are readable on the dark surface. */
  .ant-drawer .ant-input,
  .ant-drawer .ant-input-affix-wrapper,
  .ant-drawer .ant-input-number,
  .ant-drawer .ant-input-number .ant-input-number-input,
  .ant-drawer .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-drawer .ant-picker {
    background: ${inputBg} !important;
    border-color: ${inputBorder} !important;
    color: ${text} !important;
  }

  .ant-drawer .ant-input::placeholder,
  .ant-drawer .ant-input-affix-wrapper input::placeholder {
    color: ${textMuted} !important;
  }

  .ant-drawer .ant-select-selection-item,
  .ant-drawer .ant-select .ant-select-selection-search-input {
    color: ${text} !important;
  }

  .ant-drawer .ant-select-selection-placeholder {
    color: ${textMuted} !important;
  }

  .ant-drawer .ant-select-arrow,
  .ant-drawer .ant-select-arrow .anticon {
    color: ${textMuted} !important;
  }

  .ant-drawer .ant-drawer-footer {
    border-top-color: ${panelBorder} !important;
  }

  /* Package builder — match EU6 rate calculator page (ink background, subtle KPI cards) */
  .ant-modal.calculator-package-modal .ant-modal-content,
  .ant-modal.calculator-package-modal .ant-modal-header,
  .ant-modal.calculator-package-modal .ant-modal-body,
  .ant-modal.calculator-package-modal .ant-modal-footer {
    background: ${pageBg} !important;
  }

  .ant-modal.calculator-package-modal .ant-modal-header {
    border-bottom-color: ${panelBorder} !important;
  }

  .ant-modal.calculator-package-modal .ant-modal-footer {
    border-top-color: ${panelBorder} !important;
  }

  /* Excel scenario budgets — light surface (white) on the dark shell */
  .ant-modal.excel-scenarios-modal .ant-modal-content,
  .ant-modal.excel-scenarios-modal .ant-modal-header,
  .ant-modal.excel-scenarios-modal .ant-modal-body,
  .ant-modal.excel-scenarios-modal .ant-modal-footer {
    background: #ffffff !important;
  }

  .ant-modal.excel-scenarios-modal .ant-modal-header {
    border-bottom: 1px solid rgba(10, 10, 54, 0.1) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-modal-footer {
    border-top: 1px solid rgba(10, 10, 54, 0.1) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-modal-title,
  .ant-modal.excel-scenarios-modal .ant-modal-body {
    color: ${BRAND.ink} !important;
  }

  .ant-modal.excel-scenarios-modal .ant-modal-close {
    color: ${BRAND.ink_50} !important;
  }

  .ant-modal.excel-scenarios-modal .ant-modal-close:hover {
    color: ${BRAND.ink} !important;
    background: rgba(10, 10, 54, 0.06) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-input,
  .ant-modal.excel-scenarios-modal .ant-input-affix-wrapper,
  .ant-modal.excel-scenarios-modal .ant-input-group .ant-input {
    background: #ffffff !important;
    border-color: rgba(10, 10, 54, 0.18) !important;
    color: ${BRAND.ink} !important;
  }

  .ant-modal.excel-scenarios-modal .ant-input::placeholder,
  .ant-modal.excel-scenarios-modal .ant-input-affix-wrapper input::placeholder {
    color: rgba(10, 10, 54, 0.4) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-input-group-addon {
    background: ${BRAND.electric} !important;
    border-color: ${BRAND.electric} !important;
    color: #ffffff !important;
    font-weight: 600;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-default {
    color: ${BRAND.electric} !important;
    background: #ffffff !important;
    border-color: rgba(11, 23, 117, 0.35) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-default:hover {
    color: ${BRAND.electric} !important;
    background: ${BRAND.electric_10} !important;
    border-color: ${BRAND.electric} !important;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-default:disabled {
    color: rgba(10, 10, 54, 0.35) !important;
    background: rgba(10, 10, 54, 0.04) !important;
    border-color: rgba(10, 10, 54, 0.12) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-primary {
    background: ${BRAND.electric} !important;
    border-color: ${BRAND.electric} !important;
    color: #ffffff !important;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-primary:hover {
    background: ${BRAND.ink} !important;
    border-color: ${BRAND.ink} !important;
    color: #ffffff !important;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-primary:disabled {
    background: rgba(11, 23, 117, 0.35) !important;
    border-color: transparent !important;
    color: rgba(255, 255, 255, 0.85) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-link {
    color: ${BRAND.electric} !important;
  }

  .ant-modal.excel-scenarios-modal .ant-btn-link:hover {
    color: ${BRAND.ink} !important;
  }

  .ant-modal.excel-scenarios-modal .ant-modal-footer .ant-btn-default {
    color: ${BRAND.electric} !important;
    background: #ffffff !important;
    border-color: rgba(11, 23, 117, 0.35) !important;
  }

  .ant-modal.excel-scenarios-modal .ant-modal-footer .ant-btn-default:hover {
    color: ${BRAND.ink} !important;
    border-color: ${BRAND.ink} !important;
    background: ${BRAND.electric_10} !important;
  }

  .ant-modal .ant-modal-header {
    background: ${panelBg} !important;
    border-bottom-color: ${panelBorder} !important;
  }

  .ant-modal .ant-modal-title,
  .ant-modal .ant-modal-body,
  .ant-modal .ant-modal-confirm-title,
  .ant-modal .ant-modal-confirm-content {
    color: ${textStrong} !important;
  }

  .ant-modal .ant-modal-close {
    color: ${textMuted} !important;
  }

  .ant-modal .ant-modal-footer {
    border-top-color: ${panelBorder} !important;
  }

  .ant-modal .ant-form-item-label > label {
    color: ${textBody} !important;
  }

  .ant-modal .ant-form-item-explain,
  .ant-modal .ant-form-item-extra {
    color: ${textMuted} !important;
  }

  .ant-modal .ant-checkbox-wrapper {
    color: ${textBody} !important;
  }

  .ant-modal .ant-checkbox-wrapper span:not(.ant-checkbox) {
    color: ${textBody} !important;
  }

  .ant-modal .ant-segmented {
    background: ${hoverBg} !important;
  }

  .ant-modal .ant-segmented .ant-segmented-item {
    color: ${textSubtle} !important;
  }

  .ant-modal .ant-segmented .ant-segmented-item-selected {
    color: ${chipText} !important;
    background: ${chipBg} !important;
  }

  .ant-modal .ant-checkbox .ant-checkbox-inner {
    background-color: ${inputBg} !important;
    border-color: ${inputBorder} !important;
  }

  .ant-modal .ant-checkbox-checked .ant-checkbox-inner,
  .ant-modal .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${accent} !important;
    border-color: ${accent} !important;
  }

  .ant-modal .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border-color: ${accent} !important;
  }

  .ant-modal .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: ${onAccent} !important;
  }

  .ant-modal .ant-input-number-disabled,
  .ant-modal .ant-input-number-disabled .ant-input-number-input,
  .ant-modal .ant-input-number[disabled] .ant-input-number-input {
    color: ${textMuted} !important;
    background: ${tableRowHoverBg} !important;
  }

  .ant-modal .ant-input,
  .ant-modal .ant-input-affix-wrapper,
  .ant-modal .ant-input-number,
  .ant-modal .ant-input-number .ant-input-number-input,
  .ant-modal .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-modal .ant-picker {
    background: ${inputBg} !important;
    border-color: ${inputBorder} !important;
    color: ${text} !important;
  }

  .ant-modal .ant-input-number-prefix,
  .ant-modal .ant-input-number-suffix,
  .ant-modal .ant-input-prefix,
  .ant-modal .ant-input-suffix,
  .ant-modal .ant-input-affix-wrapper .ant-input-prefix,
  .ant-modal .ant-input-affix-wrapper .ant-input-suffix {
    color: ${text} !important;
  }

  .ant-modal .ant-descriptions-item-label,
  .ant-modal .ant-descriptions-item-content {
    color: ${textStrong} !important;
  }

  .ant-modal .ant-descriptions-bordered .ant-descriptions-view {
    border-color: ${descriptionsStrongBorder} !important;
    border-width: 2px !important;
  }

  .ant-modal .ant-descriptions-bordered .ant-descriptions-item-label,
  .ant-modal .ant-descriptions-bordered .ant-descriptions-item-content,
  .ant-modal .ant-descriptions-bordered .ant-descriptions-row > th,
  .ant-modal .ant-descriptions-bordered .ant-descriptions-row > td {
    border-color: ${descriptionsStrongBorder} !important;
    border-width: 1px !important;
    background: ${descriptionsBg} !important;
    color: ${textStrong} !important;
  }

  .ant-modal .ant-input-number-group-addon,
  .ant-modal .ant-input-group-addon,
  .ant-modal .ant-input-number-group-wrapper .ant-input-number-group-addon,
  .ant-modal .ant-input-number-group .ant-input-number-group-addon,
  .ant-modal .ant-input-number-group-wrapper .ant-input-group-addon,
  .app-shell-main .ant-input-number-group-addon,
  .app-shell-main .ant-input-group-addon,
  .ant-layout-content .ant-input-number-group-addon,
  .ant-layout-content .ant-input-group-addon {
    background: ${inputBg} !important;
    border-color: ${inputBorder} !important;
    color: ${text} !important;
  }

  .ant-modal .ant-input-number-group-addon > *,
  .ant-modal .ant-input-group-addon > *,
  .app-shell-main .ant-input-number-group-addon > *,
  .ant-layout-content .ant-input-number-group-addon > * {
    color: ${text} !important;
  }

  .ant-modal .ant-picker .ant-picker-input > input {
    color: ${text} !important;
  }

  .ant-modal .ant-picker .ant-picker-input > input::placeholder {
    color: ${textMuted} !important;
  }

  .ant-modal .ant-picker-suffix,
  .ant-modal .ant-picker-suffix .anticon,
  .ant-modal .ant-picker-range-separator,
  .ant-modal .ant-picker-range-separator .anticon,
  .ant-modal .ant-picker-clear,
  .ant-modal .ant-picker-clear .anticon {
    color: ${textBody} !important;
  }

  .ant-modal .ant-picker-suffix .anticon svg,
  .ant-modal .ant-picker-range-separator .anticon svg,
  .ant-modal .ant-picker-clear .anticon svg {
    fill: currentColor;
  }

  .ant-modal .ant-input::placeholder,
  .ant-modal .ant-input-affix-wrapper input::placeholder,
  .ant-modal .ant-input-number-input::placeholder {
    color: ${textMuted} !important;
  }

  .ant-modal .ant-select-selection-item,
  .ant-modal .ant-select-selection-placeholder {
    color: ${text} !important;
  }

  .ant-modal .ant-select-multiple .ant-select-selection-item {
    background: ${chipBg} !important;
    color: ${chipText} !important;
    border: 1px solid ${chipBorder} !important;
  }

  .ant-modal .ant-select-multiple .ant-select-selection-item-remove {
    color: ${textSubtle} !important;
  }

  .ant-modal .ant-select-multiple .ant-select-selection-item-remove:hover {
    color: ${chipText} !important;
  }

  .ant-modal .ant-select-disabled.ant-select-multiple .ant-select-selection-item {
    background: ${chipDisabledBg} !important;
    color: ${textSubtle} !important;
    border-color: ${chipDisabledBorder} !important;
  }

  .ant-modal .ant-select .ant-select-selection-search-input {
    color: ${text} !important;
  }

  .ant-modal .ant-select-selection-placeholder {
    color: ${textMuted} !important;
  }

  .ant-modal .ant-select-arrow,
  .ant-modal .ant-input-number-handler-wrap {
    color: ${textMuted} !important;
  }

  .ant-modal .ant-typography {
    color: ${textStrong} !important;
  }

  .ant-modal .ant-typography.ant-typography-secondary {
    color: ${textMuted} !important;
  }

  .ant-modal .ant-card {
    background: ${panelBg} !important;
    border-color: ${panelBorder} !important;
    color: ${text};
  }

  .ant-modal .ant-card.metric-card {
    background: ${metricCardBg} !important;
    border-color: ${metricCardBorder} !important;
    box-shadow: none !important;
  }

  .ant-modal .ant-card.metric-card .ant-card-body {
    background: transparent !important;
  }

  .ant-modal .ant-card-head {
    border-bottom-color: ${panelBorder} !important;
  }

  .ant-modal .ant-card-head-title {
    color: ${textStrong} !important;
  }

  .ant-modal .ant-card-body {
    color: ${textStrong} !important;
  }

  .ant-modal .ant-table-thead > tr > th {
    background: ${tableHeaderBg} !important;
    color: ${accentText} !important;
    border-bottom: 1px solid ${panelBorder} !important;
  }

  .ant-modal .ant-table-tbody > tr > td {
    background: transparent !important;
    color: ${textStrong} !important;
    border-bottom: 1px solid ${tableRowBorder} !important;
  }

  .ant-modal .ant-table-tbody > tr:hover > td {
    background: ${tableRowHoverBg} !important;
  }

  .ant-modal .ant-table-tbody a:not(.ant-btn) {
    color: ${textBody} !important;
  }

  /* —— In-table text links —— */
  .app-shell-main .ant-table-tbody a:not(.ant-btn),
  .ant-layout-content .ant-table-tbody a:not(.ant-btn) {
    color: ${textBody} !important;
  }

  .app-shell-main .ant-table-tbody a:not(.ant-btn):hover,
  .ant-layout-content .ant-table-tbody a:not(.ant-btn):hover {
    color: ${text} !important;
  }

  /* —— Page intro copy —— */
  .app-shell-page-intro {
    color: ${textMuted};
    font-size: 14px;
    line-height: 1.6;
    max-width: 820px;
    margin: 0 0 20px;
  }

  /* —— Dividers / collapse —— */
  .app-shell-main .ant-divider,
  .ant-layout-content .ant-divider {
    border-color: ${panelBorder} !important;
  }

  .app-shell-main .ant-collapse,
  .ant-layout-content .ant-collapse {
    background: ${panelBg} !important;
    border-color: ${panelBorder} !important;
  }

  .app-shell-main .ant-collapse-header,
  .ant-layout-content .ant-collapse-header {
    color: ${textStrong} !important;
  }

  /* —— Tabs —— */
  .app-shell-main .ant-tabs .ant-tabs-tab,
  .ant-layout-content .ant-tabs .ant-tabs-tab {
    color: ${textMuted} !important;
  }

  .app-shell-main .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn,
  .ant-layout-content .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn {
    color: inherit !important;
  }

  .app-shell-main .ant-tabs .ant-tabs-tab-active,
  .app-shell-main .ant-tabs .ant-tabs-tab-active .ant-tabs-tab-btn,
  .ant-layout-content .ant-tabs .ant-tabs-tab-active,
  .ant-layout-content .ant-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${text} !important;
  }

  .app-shell-main .ant-tabs .ant-tabs-tab:hover,
  .app-shell-main .ant-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn,
  .ant-layout-content .ant-tabs .ant-tabs-tab:hover,
  .ant-layout-content .ant-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: ${textBody} !important;
  }

  .app-shell-main .ant-tabs .ant-tabs-ink-bar,
  .ant-layout-content .ant-tabs .ant-tabs-ink-bar {
    background: ${accent} !important;
  }

  /* —— Confirm dialogs (close without saving, delete, etc.) —— */
  .ant-modal.ant-modal-confirm .ant-modal-content {
    background: ${panelBg} !important;
    border: 1px solid ${panelBorder};
  }

  .ant-modal-confirm .ant-modal-confirm-body {
    color: ${textStrong} !important;
  }

  .ant-modal-confirm .ant-modal-confirm-body > .anticon {
    color: ${APP_SHELL_THEME.negative} !important;
    font-size: 22px;
    margin-top: 2px;
  }

  .ant-modal-confirm .ant-modal-confirm-title,
  .ant-modal-confirm .ant-modal-confirm-body .ant-typography,
  .ant-modal-confirm .ant-modal-confirm-body h1,
  .ant-modal-confirm .ant-modal-confirm-body h2,
  .ant-modal-confirm .ant-modal-confirm-body h3,
  .ant-modal-confirm .ant-modal-confirm-body h4,
  .ant-modal-confirm .ant-modal-confirm-body h5 {
    color: ${textStrong} !important;
  }

  .ant-modal-confirm .ant-modal-confirm-content {
    color: ${textMuted} !important;
    font-size: 14px;
    line-height: 1.5;
    margin-top: 8px;
  }

  .ant-modal-confirm .ant-modal-confirm-btns {
    margin-top: 24px;
  }

  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
    background: ${accent} !important;
    border-color: ${accent} !important;
    color: ${onAccent} !important;
    font-weight: 500;
    box-shadow: none !important;
  }

  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover {
    background: ${accentHover} !important;
    border-color: ${accentHover} !important;
    color: ${onAccent} !important;
  }

  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default,
  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-text:not(.ant-btn-dangerous) {
    color: ${textBody} !important;
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default:hover,
  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-text:not(.ant-btn-dangerous):hover {
    color: ${text} !important;
    background: ${hoverBg} !important;
  }

  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-dangerous,
  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-text.ant-btn-dangerous {
    color: ${APP_SHELL_THEME.negative} !important;
    background: transparent !important;
    font-weight: 600;
  }

  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-dangerous:hover,
  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-text.ant-btn-dangerous:hover {
    color: ${negativeText} !important;
    background: rgba(255, 77, 79, 0.12) !important;
  }
`;
